module.exports = __webpack_public_path__ + "img/Background.42457510.png";